import React from "react";
import { SignInButton } from "../components/SignInButton";
import { Box, Grid2 } from "@mui/material";

export default function Login() {
  return (
    <Box sx={{ height: "98vh", padding: "25vh 0" }}>
      <Grid2 container rowSpacing={5}>
        <Grid2 size={12}>
          <Box sx={{ height: "16vh", display: "flex" }}>
            <img
              src={"./logo.png"}
              alt="logo"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </Box>
        </Grid2>
        <Grid2 size={12} sx={{ textAlign: "center" }}>
          <SignInButton />
        </Grid2>
      </Grid2>
    </Box>
  );
}
